import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../images/logo.png'
import { FaLinkedin } from 'react-icons/fa';
import { FaFacebook } from 'react-icons/fa'
import { AiOutlineTwitter } from 'react-icons/ai'
import { AiFillInstagram } from 'react-icons/ai'


const Footor = () => {
  return (
    <footer>
           
           
      <div className="container footor_container">

<article>
<Link to="/" className='logo'>

<img src={Logo} alt="" />
</Link>
<p>

  Lorem ipsum dolor, sit amet consectetur adipisicing elit,
  Blanditiis perferendis dolores facere libero .

</p>
<div className="socials_footo">

<a href="https://linkedin.com/" target='_blank' rel='noreferrer noopener'>
           
           <FaLinkedin/>

</a>
<a href="https://facebook.com/" target='_blank' rel='noreferrer noopener'>
           
           <FaFacebook/>

</a>
<a href="https://twitter.com/" target='_blank' rel='noreferrer noopener'>
           
           <AiOutlineTwitter/>

</a>
<a href="https://instagram.com/" target='_blank' rel='noreferrer noopener'>
           
           <AiFillInstagram/>

</a>


</div>

</article>
<article>
  <h4>Permalinks</h4>
  <Link to='/about'>About</Link>
  <Link to='/plans'>plans</Link>
  <Link to='/trainers'>Trainers</Link>
  <Link to='/gallary'>Gallary</Link>
  <Link to='/contact'>Contact</Link>


</article>

<article>
  <h4> Insights </h4>
  <Link to='/s'>Blog</Link>
  <Link to='/s'>Case Studies</Link>
  <Link to='/s'>Events</Link>
  <Link to='/s'>Communities</Link>
  <Link to='/s'>FAQS</Link>


</article>


<article>
  <h4>Get In Toutch</h4>
  <Link to='/contact'>Contact Us</Link>
  <Link to='/s'>support</Link>
  

</article> 





</div>
<div className="copyright">
<small>2023 omarkhder &copy; All Rights Reserved</small>
</div>


      
    </footer>
  )
}

export default Footor
